import { useSyncExternalStore } from "react";

const KEY = "moin-consent";
const VERSION = 1;
const listeners = new Set();
let bannerOpen = false;

const read = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c?.v === VERSION ? c : null;
  } catch {
    return null;
  }
};

let state = { consent: read(), open: false };
const emit = () => {
  state = { consent: read(), open: bannerOpen };
  listeners.forEach((l) => l());
};

export const saveConsent = (media, booking) => {
  const prev = read();
  localStorage.setItem(KEY, JSON.stringify({ v: VERSION, media, booking: booking ?? prev?.booking ?? false, date: new Date().toISOString() }));
  bannerOpen = false;
  emit();
};

export const openConsentSettings = () => { bannerOpen = true; emit(); };

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export const useConsent = () => useSyncExternalStore(subscribe, () => state);
export const useMediaAllowed = () => !!useConsent().consent?.media;
